import PocketBase, { type SendOptions } from 'pocketbase'
import { useAppStorage } from '~/config/useConfigStorage'

export default defineNuxtPlugin(nuxtApp => {
  const { pbURL } = useRuntimeConfig().public
  if (!pbURL) return console.error('请配置pb服务')

  const { configStorageKey } = useConfigStatic()
  const { storageFP } = useAppStorage()

  const pb = new PocketBase(pbURL)

  /** 请求拦截 */
  pb.beforeSend = function (url: string, options: SendOptions) {
    options.headers = {
      ...options.headers,
      [configStorageKey.FINGERPRINT]: storageFP.value,
    }
    return { url, options }
  }

  /** 响应拦截 */
  pb.afterSend = function (response: Response, data: any) {
    // if (!response.ok) {
    //   toast.add({
    //     description: t('message.error.fetch', { errCode: response.status }),
    //     color: 'error',
    //   })
    // }
    return Object.assign(data, {
      // 自定义拓展
      // "additionalField": 123,
    })
  }

  return {
    provide: {
      pb,
    },
  }
})
